import { useState, useEffect } from "react";
import "./Plugins.css";
import { GmailBanner } from "../banners/GmailBanner";

export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/winslow-hr-gmail-extensio/ngobppjdahkgldgjchgojleclpecookm?authuser=8&hl=en";

const Plugins = () => {
  useEffect(() => {}, []);

  //   console.log("[Plugins] : ", );

  return (
    <div id="plugins">
      <div className="page-title" style={{ marginBottom: "0px" }}>
        Get the Gmail Plugin
      </div>

      <div
        className="plugins-gmail-banner"
        onClick={() => window.open(CHROME_STORE_URL, "__new")}>
        <GmailBanner />
      </div>
    </div>
  );
};

export default Plugins;
